import * as swcHelpers from '@swc/helpers';
import { useMemo } from 'react';
import { useQuery } from '@grandvisionhq/graphql';
import useVirtualAppointment from './useVirtualAppointment.js';
import { toAppointments } from '../mappers/appointment.js';
import GET_MY_APPOINTMENTS from '../operations/queries/get-my-appointments.js';

const useAppointments = ()=>{
    var ref;
    const { data , loading , error  } = useQuery(GET_MY_APPOINTMENTS);
    const { isVirtualAppointmentType  } = useVirtualAppointment();
    const allAppointmentsList = data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.appointments;
    // filter appointments to add isVirtualAppointment flag
    const filteredAppointmentsData = allAppointmentsList === null || allAppointmentsList === void 0 ? void 0 : allAppointmentsList.map((appointment)=>{
        if (isVirtualAppointmentType(appointment.appointmentType)) {
            return swcHelpers.objectSpread({}, appointment, {
                isVirtualAppointment: true
            });
        }
        return swcHelpers.objectSpread({}, appointment, {
            isVirtualAppointment: false
        });
    });
    return useMemo(()=>({
            data: toAppointments(filteredAppointmentsData),
            loading,
            error
        })
    , [
        error,
        filteredAppointmentsData,
        loading
    ]);
};

export { useAppointments };
//# sourceMappingURL=useAppointments.js.map
